// extracted by mini-css-extract-plugin
module.exports = {"white_backgdrop":"canvasBackground_white_backgdrop__3ReFb","inner":"canvasBackground_inner__bRI0n","placeholder":"canvasBackground_placeholder__3R0cf"};